<script setup lang="ts">
    withDefaults(
        defineProps<{
            is?: 'div' | 'p'
            icon?: string
        }>(),
        {
            is: 'div',
            icon: 'ri:information-line',
        },
    )
</script>

<template>
    <component :is="is" class="pk-infobox">
        <VvIcon :name="icon" />
        <slot />
    </component>
</template>

<style lang="scss">
    @layer volver.components {
        .pk-infobox {
            font-size: var(--text-12);
            color: var(--color-word-3);
            line-height: var(--leading-normal);
            margin-bottom: var(--spacing-md);
            padding-block: var(--spacing-10);
            background-color: var(--color-surface-1);
            border: 1px solid var(--color-surface-3);
            padding-left: var(--spacing-36);
            padding-right: var(--spacing-xs);
            display: block;
            position: relative;
            border-radius: var(--rounded-lg);

            & > .vv-icon {
                font-size: var(--text-18);
                position: absolute;
                left: var(--spacing-8);
            }
        }
    }
</style>
